import { clientSessionViewStore } from '../../services/clientSessionViewStore.js'
import { logger } from './logger-client.js'

export const PERSONA_SESSION_STORAGE_KEYS = [
  'fbc_briefing_confirmed',
  'fbc_user_profile',
] as const

export interface ResetPersonaSessionOptions {
  /** Clear sessionStorage briefing gate only (default true). */
  clearBriefingGate?: boolean
}

/**
 * Reset client-side persona context so a new intake/direct path cannot inherit
 * stale research, transcript, or intelligence from a prior session.
 */
export function resetPersonaSessionContext(options?: ResetPersonaSessionOptions): void {
  const { clearBriefingGate = true } = options ?? {}

  if (typeof window !== 'undefined' && clearBriefingGate) {
    for (const key of PERSONA_SESSION_STORAGE_KEYS) {
      sessionStorage.removeItem(key)
    }
  }

  clientSessionViewStore.resetPersonaContext()
  logger.debug('[persona-session-reset] Client persona context cleared')
}

export function shouldResetPersonaForEmail(
  previousEmail: string | undefined,
  nextEmail: string
): boolean {
  const prev = previousEmail?.trim().toLowerCase()
  const next = nextEmail.trim().toLowerCase()
  if (!prev) return false
  return prev !== next
}
